import { render, staticRenderFns } from "./Mangas.vue?vue&type=template&id=62cede99"
import script from "./Mangas.vue?vue&type=script&lang=ts"
export * from "./Mangas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports